import { Podcast } from '../../types';

const getUrlPathForPodcastPublicProfile = (podcast: Podcast): string =>
  `/${encodeURIComponent(podcast.vanitySlug)}`;

const getUrlPathForPodcastEmbed = (podcast: Podcast): string =>
  `/${encodeURIComponent(podcast.vanitySlug)}/embed`;

const getUrlPathForMoney = (): string => '/dashboard/money';

/**
 * @deprecated
 */
const AnchorClientRoutes = {
  getUrlPathForMoney,
  getUrlPathForPodcastEmbed,
  getUrlPathForPodcastPublicProfile,
};

export { AnchorClientRoutes };
